/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Backdrop, Fade, Modal } from "@material-ui/core";
import { forwardRef, Fragment, ReactNode } from "react";
import {
  Button,
  ClearIcon,
  ModalContainer,
  ModalContent,
  modalCss,
  ModalHeader,
  ModalTitle,
} from "./styles";

const MODAL_TITLE_ID = "flowio-modal-title";
const MODAL_DESCRIPTION_ID = "flowio-modal-description";

export type ModalSizes = "small" | "medium" | "large" | "extraLarge";

type Props = {
  isOpen: boolean;
  title: string;
  children: ReactNode;
  size?: ModalSizes;
  toggle(): void;
};

const FlowioModal = forwardRef<HTMLDivElement, Props>(
  ({ isOpen, title, children, size = "extraLarge", toggle }, ref) => (
    <Modal
      open={isOpen}
      onClose={toggle}
      aria-labelledby={MODAL_TITLE_ID}
      aria-describedby={MODAL_DESCRIPTION_ID}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      closeAfterTransition
      css={modalCss}
    >
      <Fade in={isOpen}>
        <Fragment>
          <ModalContainer size={size} data-cy="modal-content" ref={ref}>
            <ModalHeader>
              <ModalTitle id={MODAL_TITLE_ID}>{title}</ModalTitle>
              <Button data-cy="close-button" type="button" onClick={toggle}>
                <ClearIcon />
              </Button>
            </ModalHeader>
            <ModalContent id={MODAL_DESCRIPTION_ID} data-cy="modal-body">
              {children}
            </ModalContent>
          </ModalContainer>
        </Fragment>
      </Fade>
    </Modal>
  )
);

export default FlowioModal;
